const pageNameKey = "otaHistory";

export const otaHistoryEn = {
  [pageNameKey]: {
    firmwareVersionsText: "Firmware Versions",
    firmwareBackupsText: "Firmware Backups",
    uploadFirmwareReleaseText: "Upload Firmware Release",
    uploadFirmwareBackupText: "Upload Firmware Backup",
    uploadConfigurationsReleaseText: "Upload Configuration Release",
    configurationsText: "Configurations",
    createBackupText: "Create Backup",
    createBackupDisabledText:
      "Complete the firmware update before creating a backup",
    backupsText: "Backups",
  },
};

export const otaHistoryPtBr = {
  [pageNameKey]: {
    firmwareVersionsText: "Versões do firmware",
    firmwareBackupsText: "Backups de firmware",
    uploadFirmwareReleaseText: "Enviar versão do firmware",
    uploadFirmwareBackupText: "Enviar backup do firmware",
    uploadConfigurationsReleaseText: "Enviar versão da configuração",
    configurationsText: "Configurações",
    createBackupText: "Criar backup",
    createBackupDisabledText:
      "Conclua a atualização do firmware antes de criar um backup",
    backupsText: "Backups",
  },
};

export const otaHistoryDe = {
  [pageNameKey]: {
    firmwareVersionsText: "Firmware-Versionen",
    firmwareBackupsText: "Firmware-Backups",
    uploadFirmwareReleaseText: "Firmware-Release hochladen",
    uploadFirmwareBackupText: "Firmware-Backup hochladen",
    uploadConfigurationsReleaseText: "Konfigurationsversion hochladen",
    configurationsText: "Konfigurationen",
    createBackupText: "Backup erstellen",
    createBackupDisabledText:
      "Schließen Sie die Firmware-Aktualisierung ab, bevor Sie ein Backup erstellen",
    backupsText: "Backups",
  },
};

export const otaHistoryZhHans = {
  [pageNameKey]: {
    firmwareVersionsText: "固件版本",
    firmwareBackupsText: "固件备份",
    uploadFirmwareReleaseText: "上传固件版本",
    uploadFirmwareBackupText: "上传固件备份",
    uploadConfigurationsReleaseText: "上传配置发布",
    configurationsText: "配置",
    createBackupText: "创建备份",
    createBackupDisabledText: "请在创建备份前完成固件更新",
    backupsText: "备份",
  },
};

export const otaHistoryIt = {
  [pageNameKey]: {
    firmwareVersionsText: "Versioni firmware",
    firmwareBackupsText: "Copia di backup del firmware",
    uploadFirmwareReleaseText: "Carica una versione del firmware",
    uploadFirmwareBackupText: "Carica un backup del firmware",
    uploadConfigurationsReleaseText: "Carica una versione della configurazione",
    configurationsText: "Configurazioni",
    createBackupText: "Crea backup",
    createBackupDisabledText:
      "Completa l'aggiornamento del firmware prima di creare un backup",
    backupsText: "Backup",
  },
};

export const otaHistoryEs = {
  [pageNameKey]: {
    firmwareVersionsText: "Versiones de firmware",
    firmwareBackupsText: "Copias de seguridad del firmware",
    uploadFirmwareReleaseText: "Subir versión de firmware",
    uploadFirmwareBackupText: "Subir copia de seguridad del firmware",
    uploadConfigurationsReleaseText: "Subir versión de configuración",
    configurationsText: "Configuraciones",
    createBackupText: "Crear copia de seguridad",
    createBackupDisabledText:
      "Completa la actualización del firmware antes de crear una copia de seguridad",
    backupsText: "Copias de seguridad",
  },
};

export const otaHistoryNl = {
  [pageNameKey]: {
    backupsText: "Back-ups",
    configurationsText: "Configuraties",
    createBackupText: "Back-up maken",
    createBackupDisabledText:
      "Voltooi de firmware-update voordat u een back-up maakt",
    firmwareBackupsText: "Firmwareback-ups",
    firmwareVersionsText: "Firmwareversies",
    uploadConfigurationsReleaseText: "Configuratie-release uploaden",
    uploadFirmwareBackupText: "Firmwareback-up uploaden",
    uploadFirmwareReleaseText: "Firmware-release uploaden",
  },
};

export const otaHistoryTr = {
  [pageNameKey]: {
    backupsText: "Yedeklemeler",
    configurationsText: "Yapılandırmalar",
    createBackupText: "Yedekleme Oluştur",
    createBackupDisabledText:
      "Yedekleme oluşturmadan önce ürün yazılımı güncellemesini tamamlayın",
    firmwareBackupsText: "Firmware Yedeklemeleri",
    firmwareVersionsText: "Donanım Yazılımı Sürümleri",
    uploadConfigurationsReleaseText: "Yapılandırma Sürümünü Yükle",
    uploadFirmwareBackupText: "Ürün Yazılımı Yedeklemesini Yükle",
    uploadFirmwareReleaseText: "Donanım Yazılımı Sürümünü Yükle",
  },
};
